import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Collapse, Card } from "react-bootstrap";

const Home_Info = () => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("More");

  function handleCollapse() {
    setOpen(!open);
    if (!open ? setText("Less") : setText("More"));
  }

  function handleCloseInfo() {
    setOpen(false);
    setText("More");
  }

  return (
    <section className="retrobg container py-5">
      <br />
      <h3 className="fw-bold text-center">
        London Kickboxing – Dynamic Kickboxing Classes
      </h3>
      <p className="mt-3">
        <p className="text-center" style={{ fontSize: "22px" }}>
          Established in 1998, London Kickboxing has helped people across London
          to achieve inner <br />
          confidence, physical and mental strength, and assured striking power
          for over twenty years.
          <br />
          <br />
          <Button className="btn btn-danger" onClick={() => handleCollapse()}>Read {text}</Button>
        </p>
      </p>

      <Collapse in={open}>
        <Card className="lkbxbg6">
          <Card.Body>
            <img
              className={
                "img-rounded img-responsive visible-md visible-lg pull-right"
              }
              id="lkbx-img-r"
              src="./img/lkbx_info.jpg"
              title="London Kickboxing – Dynamic Kickboxing Classes"
              alt="London Kickboxing – Dynamic Kickboxing Classes"
              width="300"
            />
            <p style={{ fontSize: "20px" }}>
              We have two locations in Acton and Chiswick and welcome anyone
              who’d like to participate, from aged six and older. You’ll learn
              how to defend yourself, use your natural weight and physicality to
              overpower and subdue and opponent through a range of techniques or
              hone your existing skills. Our experienced instructors have the
              accreditations, skillsets and experience to help you to achieve
              your goals.
            </p>
            <br />
            <p style={{ fontSize: "20px" }}>
              <strong>Why Kickboxing?</strong>
              <br />
              Kickboxing is a fast, dynamic and effective martial art that’s
              famed for its strong vertical standing techniques, kickboxing
              merges traditional boxing techniques with leg striking. There are
              many benefits to joining kickboxing self-defence classes – one of
              the reasons why the martial art has transcended combative training
              and is today praised for being one of the best fitness regimes
              that anyone can undertake. Those choosing to participate in one of
              our classes can benefit from weight loss, muscle toning, and
              strength building as part of a motivating and energising workout.
              You could also see your stress levels reducing, improved
              coordination, and even better flexibility as you learn to control
              your own body and mind. Our kickboxing academy, based in locations
              Ealing and Chiswick, will help you to achieve these benefits
              through expert tuition and training.
              <br />
              <br />
              <strong>Our Courses</strong>
              <br />
              Our courses are separated into both child and adult categories and
              are arranged according to skill and experience levels. Children
              aged six to thirteen are encouraged to come along to either Ealing
              or Chiswick and take part. Come along to our adult courses in
              Ealing and Chiswick and unlock your natural striking power,
              improve your fitness and bolster your psychological and physical
              health. Courses are open to anyone over the age of fourteen. We
              teach progressive techniques and can provide tailored one-on-one
              tuition or group training. Sparring is optional, practiced under
              strict supervision and encourages only light contact. In addition
              to our kickboxing classes, we also provide one-on-one personal
              training. Enhance your stamina, strength, durability and
              flexibility whilst learning prolonged concentration and
              determination. We’re happy to offer well-rounded one-on-one
              personal training or focus on a specific area of your fitness that
              you’d like to improve. Classes are held at the gym/studio we use
              in Kensington, at your home or place of work or large outdoor
              space, such as a local park.
            </p>
            <Link
              to="#"
              className="btn btn-link"
              onClick={() => handleCloseInfo()}
            >
              <i>Close</i>
            </Link>
          </Card.Body>
        </Card>
      </Collapse>
    </section>
  );
};

export default Home_Info;
